import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=7912cd2f&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7912cd2f')) {
      api.createRecord('7912cd2f', component.options)
    } else {
      api.reload('7912cd2f', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=7912cd2f&", function () {
      api.rerender('7912cd2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/checkbox/checkbox.vue"
export default component.exports